var map = {
	"./_MG_2751_3.webp": "./src/img/brands/farmacias/_MG_2751_3.webp",
	"./_MG_3010_3.webp": "./src/img/brands/farmacias/_MG_3010_3.webp",
	"./_MG_3228_3.webp": "./src/img/brands/farmacias/_MG_3228_3.webp",
	"./_MG_3319_2.webp": "./src/img/brands/farmacias/_MG_3319_2.webp",
	"./_MG_3319_4.webp": "./src/img/brands/farmacias/_MG_3319_4.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/farmacias sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";